import React, { useState } from 'react';
import './RoutesList.css';
import { 
  Button, 
  IconButton, 
  Tooltip, 
  Snackbar, 
  Alert
} from '@mui/material';
import { 
  Share as ShareIcon,
  ContentCopy as CopyIcon
} from '@mui/icons-material';
import { agentColors } from '../theme';

const RoutesList = ({ routes }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  // Funções de formatação removidas para simplificar o MVP

  // Função para copiar rota para a área de transferência
  const copyRouteToClipboard = (route) => {
    // Formata a rota para ser compartilhada como texto
    const agentName = route.agent.name || 'Agente';
    
    // Cabeçalho com informações da rota
    let routeText = `🚚 Rota de ${agentName}\n`;
    routeText += `📍 ${route.points.length} pontos\n\n`;
    
    // Lista de pontos ordenados
    route.points.forEach((point, index) => {
      // Simplificar o formato, removendo "Point" e mostrando apenas o endereço
      routeText += `${index + 1}: ${point.address}\n`;
    });
    
    // Copia para a área de transferência
    navigator.clipboard.writeText(routeText)
      .then(() => {
        setSnackbarMessage('Rota copiada para a área de transferência!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      })
      .catch(err => {
        console.error('Erro ao copiar rota:', err);
        setSnackbarMessage('Erro ao copiar rota. Tente novamente.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  };
  
  // Função para fechar o snackbar
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <div className="routes-list">
      <h2>Rotas Otimizadas</h2>
      
      {/* Snackbar para notificações */}
      <Snackbar 
        open={snackbarOpen} 
        autoHideDuration={3000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      
      {routes.length === 0 ? (
        <p className="no-routes">Nenhuma rota encontrada.</p>
      ) : (
        <div className="routes-container">
          {routes.map((route, index) => (
            <div key={index} className="route-card">
              <div className="route-header" style={{ backgroundColor: agentColors[index % agentColors.length] }}>
                <div className="route-header-title">
                  <h3>{route.agent.name || `Agente ${index + 1}`}</h3>
                  <Tooltip title="Compartilhar rota">
                    <IconButton 
                      onClick={() => copyRouteToClipboard(route)} 
                      size="small" 
                      color="inherit"
                      sx={{ ml: 1, backgroundColor: 'rgba(255,255,255,0.2)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' } }}
                    >
                      <ShareIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </div>
                <div className="route-stats">
                  <span>{route.points.length} pontos</span>
                </div>
              </div>
              
              <ul className="points-list">
                {route.points.map((point, pointIndex) => (
                  <li key={pointIndex} className="point-item">
                    <span className="point-number" style={{ backgroundColor: agentColors[index % agentColors.length] }}>{pointIndex + 1}</span>
                    <div className="point-details">
                      <span>{point.address}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RoutesList;